import classNames from "classnames";
import { getShippingLabel } from "../../utils/country";
import { DComponent } from "../DComponent";
import { listenEvent, EVENTS } from "../../utils/event";
import { DCStatic } from "../../models/DCStatic";

export default class GroupPicker extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    curLanguage,
    curShipping,
    curCurrency,
    hideShipping,
    hideCurrency,
    hide,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("GroupPicker", {
        "only-language": hideShipping && hideCurrency,
        "hide-shipping": hideShipping,
        "hide-currency": hideCurrency,
        "hide": hide
      }),
    }, true, defaultLoading);
    this.curLanguage = curLanguage;
    this.curShipping = curShipping;
    this.curCurrency = curCurrency;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "GroupPicker");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setUpEvent();

    if (this.curLanguage) this.onLanguage(this.curLanguage);
    if (this.curShipping) this.onShipping(this.curShipping);
    if (this.curCurrency) this.onCurrency(this.curCurrency);

    listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
      this.onLanguage(data);
    })

    listenEvent(EVENTS.CHANGE_COUNTRY, (data) => {
      this.onShipping(data);
    })

    listenEvent(EVENTS.CHANGE_CURRENCY, (data) => {
      this.onCurrency(data);
    })
  }

  setUpEvent() {
    $("body").on("click", ".group-picker", (e) => {
      this.onShow();
    });
  }

  changeParent(parent) {
    parent.append(this.element);
    this.parent = parent;
  }

  onLanguage(newLang) {
    this.curLanguage = newLang;
    $(`.shipping-picker .item`, this.element).text(getShippingLabel(this.curShipping));
    $(`.language-picker .item`, this.element).text(newLang === "vi" ? "VI" : "EN");
    $(`.apps`).attr("data-hl", newLang);
  }

  onShipping(newShip) {
    this.curShipping = newShip;
    $(`.shipping-picker .item`, this.element).text(getShippingLabel(newShip));
  }

  onCurrency(newCurrency) {
    this.curCurrency = newCurrency;
    $(`.currency-picker .item`, this.element).text(newCurrency);
  }

  onShow() {
    DCStatic.modalPicker.show();
  }
}